module.exports = __webpack_public_path__ + "static/media/cancel_order_button.1492a649.svg";